'use client';

import { FC } from 'react';

import { ShallowLink } from '@ravago/shared/radiance/components/link/components/ShallowLink/ShallowLink';
import { Pagination } from '@ravago/shared/radiance/components/pagination/components/Pagination/Pagination';

import { usePaginationSerializer } from '../../../hooks/use-pagination-serializer';

interface Props {
   current: number;
   total: number;
   onChange: (page: number) => void;
}

export const ProductPortfolioPagination: FC<Props> = ({ current, total, onChange }) => {
   const serializer = usePaginationSerializer();

   return (
      <Pagination
         current={current}
         total={total}
         onChange={onChange}
         renderItem={(page, children) => {
            const serialised = serializer({ page });
            return <ShallowLink href={serialised}>{children}</ShallowLink>;
         }}
      />
   );
};
